import React from "react";
import { connect } from "react-redux";
import { Table } from 'semantic-ui-react';
//import CustomErrorField from "../../../../Form/CustomErrorField";
import CustomErrorField from "../../Form/CustomErrorField";
// import DesignRules from './DesignRules';

import { Message } from "semantic-ui-react";
import {
    setPageTitle,
    toggleNavigation,
    setMessage,
    setBreadCrum,
} from "../../../store/Page";
import api from "../../../api";
import Modal from '../ChatSetup/components/Modal';
const queryString = require("query-string");

class Notes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
           teamnotes:[],
           notesValueAi:'',
           noteerror:false,
           userToaster: false,
           userToasterMsg: "",
           userToasterColor: "",
           delete_note_id:"",
           delete_note_index:"",
           loading:false,
            disabledButton:false,
          
          };
    }

    
    componentDidMount (){
      // console.log('notes');
      this.setState({
        loading:true,
        notesValueAi:'',
        noteerror:false})
      this.loadNotesData(this.props.auto_id);
    
   }

   componentDidUpdate(prevProps, prevState) {
    if (prevProps.auto_id !== this.props.auto_id) {
        this.setState({
            loading:true,
            notesValueAi:'',
            noteerror:false
        })
        this.loadNotesData(this.props.auto_id);
        
    }
  }



   handleChange=(e)=>{
       this.setState({notesValueAi:e.target.value})
   }
  
   loadNotesData=(auto_id)=>{
    let u = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
    let clientTimeZone = u.substring(0, 3) + ':' + u.substring(3, u.length);
    let time_zone = clientTimeZone;
    const notesType = this.props.notesType || "voice";
     api.transcriptchatlist.getVoiceTeamNotes({ 'auto_id': auto_id,'time_zone':time_zone,'ref':this.props.tableref, type: notesType }).then(data => {
        
        try {
            this.setState({loading:false})
            this.setState({teamnotes:data.data.teamNotes});
          
          console.log();
  
  
        } catch (err) {
  
        }
      });
   }

    deleteNote=(note_id,index)=>{
        this.setState({
            modalstatus: true,
            delete_note_id:note_id,
            delete_note_index:index
        });
    }

    confirmDelete=()=>{
        this.setState({ loading: true, modalstatus: false});
        api.transcriptchatlist.deleteVoiceNote({ 'noteId': this.state.delete_note_id }).then(data => {
        
            try {
              
                 let notelist = this.state.teamnotes;
                
                 let index=this.state.delete_note_index;
                 notelist.splice(index, 1);
                let color = "green";
                if (data.data.status == false) {
                    color = "red";
                }
                
                this.setState({
                    teamnotes: notelist,
                    notesValueAi: '',
                    userToaster: true,
                    userToasterMsg: data.message,
                    userToasterColor: color,
                    delete_note_id: '',
                    delete_note_index: '',
                    loading:false,
                   
                },function(){
                   
                });
                if(notelist.length==0){
                    
                    this.props.updatenote(this.props.auto_id,false);
                 }

                setTimeout(
                    function () {
                        this.setState({ userToaster: false });
                    }.bind(this),
                    3000
                );
      
            } catch (err) {
      
            }
          });
    } 
   
    
    handleSubmit=(e)=>{
        e.preventDefault();
        if(this.state.notesValueAi.trim()==''){
            this.setState({
                noteerror: true,
            });
        }else{
            this.setState({
                noteerror: false,
                });
                //let datatosend = {  };
                let u = new Date().toString().match(/([-\+][0-9]+)\s/)[1];
                let clientTimeZone = u.substring(0, 3) + ':' + u.substring(3, u.length);
                let time_zone = clientTimeZone;
                let datatosend={'auto_id':this.props.auto_id,'ref':this.props.tableref,'time_zone':time_zone,'notes':this.state.notesValueAi,'type':this.props.notesType || 'voice'}
                this.setState({ loading: true,
                    disabledButton:true });
                api.transcriptchatlist.saveVoiceTeamNotes(datatosend).then(data => {
               
                    try {
                        this.setState({ 
                            loading: false,
                            disabledButton:false
                             });

                        let scrolltop=document.querySelector('.blog-comments').offsetTop - document.body.scrollTop;
                        if(scrolltop && document.querySelector('.newmodalscroll')){
                            document.querySelector('.newmodalscroll').scroll({top: scrolltop, left: 0, behavior: 'smooth' });
                        }

                        let teamnotesdata=this.state.teamnotes;

                        
                        if(teamnotesdata.length==0){
                          
                            this.props.updatenote(this.props.auto_id,true);
                        }

                        teamnotesdata.unshift(data.data.teamnotes);
                        
                        this.setState({teamnotes:teamnotesdata,notesValueAi:''});
                        document.getElementById('notes').value='';
                       
                        this.setState({
                            notesValueAi:'',
                            teamnotes:teamnotesdata,
                            userToaster: true,
                            userToasterMsg: data.message,
                            userToasterColor: 'green',
                        });
                        setTimeout(
                            function () {
                                this.setState({ userToaster: false });
                                this.props.modalClose();
                            }.bind(this),
                            3000
                        );



                    } catch (err) {
                        console.log(err);
                    }

                });
        }

       
    }


    modalFooter = () => {
        return (
            <div className="modal-footer">
                <button type="button" onClick={() => this.modalClose()} className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small" data-dismiss="modal">
                    <span>No</span>
                </button>
                <button type="button" onClick={() => this.confirmDelete(this.state.delete_note_id)}    className="btn linear-gradient yr-submitbtn btn-sm">
                <span>Yes</span>
							</button>
            </div>
        )
    }
  
    
    modalClose=()=>{
        this.setState({
            notesValueAi:'',
            modalstatus: false
        });
    }

    render() {
       
        const { teamnotes,loading }= this.state
     console.log(this.props);
        return (
            <div className="blog-comments">

                <Message
                    color={
                        this.state.userToasterColor
                            ? this.state.userToasterColor
                            : "teal"
                    }
                    style={{
                        display: this.state.userToaster ? "block" : "none",
                        marginTop: 30,
                    }}
                >
                    {this.state.userToasterMsg}
                </Message>

                <div className="c-comment-list" style={{marginTop:'20px',maxHeight:'300px',overflowY:'auto'}} >
                {loading && <div className="ui loading form"></div>}    

             </div>
             {this.props.commentform =='true' && <> 
                <form id="notesForm" method="post" onSubmit={(e)=>this.handleSubmit(e)}>
              {/* Leave Internal Notes */}
                    <div className="form-group">
                        <textarea style={{resize: "none"}} rows="5" onChange={(e)=>this.handleChange(e)} name="notes" id="notes"  value={this.state.notesValueAi} placeholder="Write notes here ..." className={
                                            this.state.noteerror 
                                                ? "form-control is-invalid"
                                                : "form-control"}></textarea>
                        {this.state.noteerror &&  (
                                                            <CustomErrorField
                                                                message="This field is required"
                                                                id="help-error"
                                                                className="error invalid-feedback"
                                                            />
                                                        )}
                    </div>
                    <div className="form-group">
                        

                        <button disabled={this.state.disabledButton} type="submit" style={{width:'100%'}} className="btn newBtnSubmit linear-gradient-cancel yr-submitbtn btn-md sbold btn-block">Submit</button>
                    </div>
                </form>
                
                {/* <button disabled={this.state.disabledButton}  style={{background:'#2786fb',color:'white'}} type="button" className="btn newBtnSubmit  btn-md sbold btn-block">Leave internal notes</button> */}
                  </>
                }
                <Modal
                   show={this.state.modalstatus}
                   footer={this.modalFooter()}
                   onclose={this.modalClose}
                   title="Confirm your action"
                   body="Do you really want to delete?"
                  />            



            </div>
        );
    }
}
export default Notes